import React, { ReactNode } from 'react';
import { Element } from './TabList.styles';

export interface TabListProps {
  children?: ReactNode;
}

const TabList = ({ children, ...props }: TabListProps) => {
  return (
    <Element role="tablist" {...props}>
      {children}
    </Element>
  );
};

export default TabList;
